/**
 * Builds the canonical public details route used by the events router.
 * The API can expose the same identifier as either `id` or `docId`.
 */
export const buildEventDetailsPath = (event = {}) => {
  const identifier = event.id || event.docId;

  return identifier
    ? `/eveniment/${encodeURIComponent(String(identifier))}`
    : "/eveniment";
};
